import React from "react";
import "./ProfileEditModal.css";

export default function StoryModal({ onClose }){
  return(
    <div className="profile-modal-overlay">
      <div className="profile-modal">
        <h2>Story (en attente)</h2>
        <p>Fonction pas encore active.</p>
        <button onClick={onClose}>OK</button>
      </div>
    </div>
  );
}
